import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { toast } from 'react-toastify';
import { gettransactionByID } from './transactionApi';

const baseUrlRfq = process.env.REACT_APP_RFQ_MANAGEMENT;
const baseUrlUser = process.env.REACT_APP_USER_MANAGEMENT;

export const getAllUserBuyer = createAsyncThunk('getAllUserBuyer', async (queryParams, { thunkAPI }) => {
    try {
        const config = queryParams ? { params: queryParams } : {};
        const response = await axios.get(`${baseUrlRfq}/getAllUsersByRole/buyer`, config);
        const result = response.data;
        return result;
    } catch (error) {
        return thunkAPI.rejectWithValue(error);
    }
});
export const getAllUserSupplier = createAsyncThunk('getAllUserSupplier', async (thunkAPI) => {
    try {
        const response = await axios.get(`${baseUrlRfq}/getAllUsersByRole/supplier`);
        const result = response.data;
        return result;
    } catch (error) {
        return thunkAPI.rejectWithValue(error);
    }
});
export const getAllPorts = createAsyncThunk('getAllPorts', async (req, { getState, thunkAPI }) => {
    const { params, isLoadMore } = req;
    try {
        const response = await axios.get(`${baseUrlRfq}/ports`, { params: params });
        const { payload, has_next, next_cursor } = response.data;
        const state = getState();
        let optionsList = payload;
        if (isLoadMore) {
            optionsList = [...state.app.rfqMang.portListForSearch, ...payload];
        }
        return { payload, optionsList, has_next, next_cursor };
    } catch (error) {
        return thunkAPI.rejectWithValue(error);
    }
});

export const getAllRfq = createAsyncThunk('getAllRfq', async (req, { thunkAPI }) => {
    const { queryParams, role } = req;
    const params = Object.fromEntries(
        Object.entries(queryParams || {}).filter(([, value]) => value !== null && value !== undefined && value !== ''),
    );
    try {
        const response =
            role === 'supplier'
                ? await axios.get(`${baseUrlRfq}/rfq/supplier`, { params })
                : await axios.get(`${baseUrlRfq}/rfq`, { params });
        const resp = response.data;
        const { milestone_count, payload, has_next, next_cursor } = response.data;
        const totalCount =
            resp?.totalCount ??
            resp?.total_count ??
            payload?.totalCount ??
            payload?.total_count ??
            resp?.pagination?.totalCount ??
            resp?.pagination?.total_count;
        return { resp, milestone_count, payload, nextPage: { has_next, next_cursor, totalCount } };
    } catch (error) {
        return thunkAPI.rejectWithValue(error);
    }
});

export const getAllVessels = createAsyncThunk('getAllVessels', async (id, thunkAPI) => {
    try {
        const response = await axios.get(`${baseUrlRfq}/vessels/${id}`);
        const { payload } = response.data;
        return payload;
    } catch (error) {
        return thunkAPI.rejectWithValue(error);
    }
});
export const getAllVesselsSupplier = createAsyncThunk('getAllVesselsSuplier', async (id, thunkAPI) => {
    try {
        const response = await axios.get(`${baseUrlRfq}/getAllBuyersForDealFinancing/${id}`);
        const { payload } = response.data;
        return payload;
    } catch (error) {
        return thunkAPI.rejectWithValue(error);
    }
});
export const getAllAgents = createAsyncThunk('getAllAgents', async (id, thunkAPI) => {
    try {
        const response = await axios.get(`${baseUrlRfq}/agents/${id}`);
        const { payload } = response.data;
        return payload;
    } catch (error) {
        return thunkAPI.rejectWithValue(error);
    }
});

export const getAllBrokers = createAsyncThunk('getAllBrokers', async (id, thunkAPI) => {
    try {
        const response = await axios.get(`${baseUrlRfq}/brokers/${id}`);
        const { payload } = response.data;
        return payload;
    } catch (error) {
        return thunkAPI.rejectWithValue(error);
    }
});

export const getAllSuppliersForPort = createAsyncThunk('getAllSuppliersForPort', async (id, thunkAPI) => {
    try {
        const response = await axios.get(`${baseUrlRfq}/getAllSuppliersForPort/${id}`);
        const { payload } = response.data;
        return payload;
    } catch (error) {
        return thunkAPI.rejectWithValue(error);
    }
});

export const getLiveprice = createAsyncThunk('getLiveprice', async (req, thunkAPI) => {
    try {
        const response = await axios.post(`${baseUrlRfq}/liveprice`, req);
        const { payload } = response.data;
        return payload;
    } catch (error) {
        return thunkAPI.rejectWithValue(error);
    }
});
export const createComplianceCheck = createAsyncThunk('createComplianceCheck', async (request, thunkAPI) => {
    const { req, dispatch, id } = request;
    try {
        const response = await axios.post(`${baseUrlRfq}/rfq/complianceCheck`, req);
        const { payload } = response.data;
        if (response) {
            toast.success(response.data.serviceMessage, {
                icon: <i className='bi bi-check-circle-fill' style={{ color: '#409895' }}></i>,
            });

            dispatch(gettransactionByID({ id, isUpdateRequired: false }));
            dispatch(getComplianceCheck(id));
        }
        return payload;
    } catch (error) {
        const errorMessage = error.response?.data?.serviceMessage || error.message;
        toast.error(errorMessage);
        return thunkAPI.rejectWithValue(errorMessage);
    }
});
export const getComplianceCheck = createAsyncThunk('getComplianceCheck', async (id, thunkAPI) => {
    try {
        const response = await axios.get(`${baseUrlRfq}/rfq/complianceCheck/${id}`);
        const { payload } = response.data;
        return payload;
    } catch (error) {
        const errorMessage = error.response?.data?.serviceMessage || error.message;
        toast.error(errorMessage);
        return thunkAPI.rejectWithValue(errorMessage);
    }
});
export const createVesselCheck = createAsyncThunk('createVesselCheck', async (request, thunkAPI) => {
    const { req, dispatch, id } = request;
    try {
        const response = await axios.post(`${baseUrlRfq}/createVesselCheck`, req);
        const { payload } = response.data;
        if (response) {
            toast.success(response.data.serviceMessage, {
                icon: <i className='bi bi-check-circle-fill' style={{ color: '#409895' }}></i>,
            });

            dispatch(gettransactionByID({ id, isUpdateRequired: false }));
            dispatch(getVesselDetails(id));
        }
        return payload;
    } catch (error) {
        const errorMessage = error.response?.data?.serviceMessage || error.message;
        toast.error(errorMessage);
        return thunkAPI.rejectWithValue(errorMessage);
    }
});
export const getVesselDetails = createAsyncThunk('getVesselDetails', async (id, thunkAPI) => {
    try {
        const response = await axios.get(`${baseUrlRfq}/getVesselDetailByRfqId/${id}`);
        const { payload } = response.data;
        return payload;
    } catch (error) {
        const errorMessage = error.response?.data?.serviceMessage || error.message;
        toast.error(errorMessage);
        return thunkAPI.rejectWithValue(errorMessage);
    }
});
export const createCreditApproval = createAsyncThunk('createCreditApproval', async (request, thunkAPI) => {
    const { req, dispatch, id } = request;
    try {
        const response = await axios.post(`${baseUrlRfq}/creditApproval`, req);
        const { payload } = response.data;
        if (response) {
            toast.success(response.data.serviceMessage, {
                icon: <i className='bi bi-check-circle-fill' style={{ color: '#409895' }}></i>,
            });

            dispatch(gettransactionByID({ id, isUpdateRequired: false }));
            dispatch(getCreditApproval(id));
        }
        return payload;
    } catch (error) {
        const errorMessage = error.response?.data?.serviceMessage || error.message;
        toast.error(errorMessage);
        return thunkAPI.rejectWithValue(errorMessage);
    }
});
export const getCreditApproval = createAsyncThunk('getCreditApproval', async (id, thunkAPI) => {
    try {
        const response = await axios.get(`${baseUrlRfq}/rfq/creditApproval/${id}`);
        const { payload } = response.data;
        return payload;
    } catch (error) {
        const errorMessage = error.response?.data?.serviceMessage || error.message;
        toast.error(errorMessage);
        return thunkAPI.rejectWithValue(errorMessage);
    }
});
export const createSupplierCreditCheck = createAsyncThunk('createSupplierCreditCheck', async (request, thunkAPI) => {
    const { req, dispatch, id } = request;
    try {
        const response = await axios.post(`${baseUrlRfq}/createSupplierCreditCheck`, req);
        const { payload } = response.data;
        if (response) {
            toast.success(response.data.serviceMessage, {
                icon: <i className='bi bi-check-circle-fill' style={{ color: '#409895' }}></i>,
            });

            dispatch(getSupplierCreditCheck(id));
            dispatch(gettransactionByID({ id, isUpdateRequired: false }));
        }
        return payload;
    } catch (error) {
        const errorMessage = error.response?.data?.serviceMessage || error.message;
        toast.error(errorMessage);
        return thunkAPI.rejectWithValue(errorMessage);
    }
});
export const getSupplierCreditCheck = createAsyncThunk('getSupplierCreditCheck', async (id, thunkAPI) => {
    try {
        const response = await axios.get(`${baseUrlRfq}/getSupplierCreditCheckByTransactionULID/${id}`);
        const { payload } = response.data;
        if (!payload) {
            return {};
        } else {
            return payload[0];
        }
    } catch (error) {
        const errorMessage = error.response?.data?.serviceMessage || error.message;
        toast.error(errorMessage);
        return thunkAPI.rejectWithValue(errorMessage);
    }
});
export const getDealFinancingSupplierDetails = createAsyncThunk(
    'getDealFinancingSupplierDetails',
    async (id, thunkAPI) => {
        try {
            const response = await axios.get(`${baseUrlRfq}/getDealFinancingSupplierDetails/${id}`);
            const { payload } = response.data;

            return payload && payload[0];
        } catch (error) {
            const errorMessage = error.response?.data?.serviceMessage || error.message;
            toast.error(errorMessage);
            return thunkAPI.rejectWithValue(errorMessage);
        }
    }
);

export const getBidList = createAsyncThunk('getBidList', async (rfqId, { thunkAPI }) => {
    try {
        const response = await axios.get(`${baseUrlRfq}/rfq/${rfqId}/bid`);
        const { payload } = response.data;
        return payload;
    } catch (error) {
        const errorMessage = error.response?.data?.serviceMessage || error.message;
        toast.error(errorMessage);
        return thunkAPI.rejectWithValue(errorMessage);
    }
});

export const getRfqDetails = createAsyncThunk('getRfqDetails', async (queryParams, { thunkAPI }) => {
    try {
        const response = await axios.get(`${baseUrlRfq}/rfq/rfqId`, { params: queryParams });
        const { payload } = response.data;
        const { port } = payload;
        return { payload, selectedPort: [port] };
    } catch (error) {
        const errorMessage = error.response?.data?.serviceMessage || error.message;
        toast.error(errorMessage);
        return thunkAPI.rejectWithValue(errorMessage);
    }
});

export const updateBid = createAsyncThunk('updateBid', async (request, thunkAPI) => {
    const { req, allRfqReq, dispatch } = request;

    try {
        const response = await axios.put(`${baseUrlRfq}/rfq/${req.rfq_ulid}/bid/${req.bid_ulid}/update`, req);

        if (response) {
            toast.success(response.serviceMessage || response?.data?.serviceMessage, {
                icon: <i className='bi bi-check-circle-fill' style={{ color: '#409895' }}></i>,
            });
            dispatch(getAllRfq(allRfqReq));
        }
        const payload = response.data;
        return payload;
    } catch (error) {
        const errorMessage = error.response?.data?.serviceMessage || error.message;
        toast.error(errorMessage);
        return thunkAPI.rejectWithValue(errorMessage);
    }
});

const fetchOrganizationNames = async () => {
    try {
        const response = await axios.get(`${baseUrlUser}/organizations`);
        return response;
    } catch (error) {
        return [];
    }
};
export const getChatGroupAction = createAsyncThunk('getChatGroupAction', async (req, thunkAPI) => {
    try {
        let chatGroups;
        const response = await axios.post(`${baseUrlRfq}/getChatGroup`, req);
        const { payload } = response.data;
        if (payload) {
            const participantIds = payload?.map((item) => item.participant_organization_ulids).flat();
            let nameArray = [];
            if (participantIds?.length !== 0) {
                nameArray = await fetchOrganizationNames();
                nameArray = nameArray.data.payload;
            }
            const updatedPayload = payload?.map((item) => ({
                ...item,
                participant_organization_names: item.participant_organization_ulids
                    .map((id) => nameArray.find((org) => org.organization_ulid === id))
                    .filter((name) => name !== undefined),
            }));

            const filteredResponse = updatedPayload.filter((group) => group.participant_organization_ulids.length > 1);
            chatGroups = filteredResponse;
            return chatGroups;
        }
        return payload;
    } catch (error) {
        return thunkAPI.rejectWithValue(error);
    }
});

export const getAllTransactionByRole = createAsyncThunk(
    'getAllTransactionByRole',
    async (requestPayload, { thunkAPI }) => {
        const { req, param } = requestPayload;
        try {
            const response = await axios.get(`${baseUrlRfq}/${req.roleName}/${req.orgId}/${req.transactionType}`, {
                params: param,
            });
            const { payload } = response.data;
            return payload;
        } catch (error) {
            const errorMessage = error.response?.data?.serviceMessage || error.message;
            const status = error.response?.status;
            // Product-access denials are handled by Unauthorized UI — avoid noisy toasts.
            if (status !== 403 && !/access denied/i.test(errorMessage || '')) {
                toast.error(errorMessage);
            }
            return thunkAPI.rejectWithValue(errorMessage);
        }
    }
);

export const getProductList = createAsyncThunk('getProductList', async (thunkAPI) => {
    try {
        const response = await axios.get(`${baseUrlRfq}/products`);
        const { payload } = response.data;
        return payload;
    } catch (error) {
        const errorMessage = error.response?.data?.serviceMessage || error.message;
        toast.error(errorMessage);
        return thunkAPI.rejectWithValue(errorMessage);
    }
});

export const getAllBrokerAssociatedBuyer = createAsyncThunk('getAllBrokerAssociatedBuyer', async (id, thunkAPI) => {
    try {
        const response = await axios.get(`${baseUrlRfq}/buyers/broker?broker_user_ulid=${id}`);
        const { payload } = response.data;
        return payload;
    } catch (error) {
        return thunkAPI.rejectWithValue(error);
    }
});

export const fetchSuppliersByPortandProducts = createAsyncThunk(
    'fetchSuppliersByPortandProducts',
    async (req, thunkAPI) => {
        try {
            const response = await axios.post(`${baseUrlRfq}/fetchSuppliersByPortandProducts`, req);
            const { payload } = response.data;
            return payload;
        } catch (error) {
            const errorMessage = error.response?.data?.serviceMessage || error.message;
            toast.error(errorMessage);
            return thunkAPI.rejectWithValue(errorMessage);
        }
    }
);

export const productsforbroker = createAsyncThunk('productsforbroker', async (queryParams, thunkAPI) => {
    try {
        const response = await axios.get(`${baseUrlRfq}/productsforbroker`, { params: queryParams });
        const { payload } = response.data;
        return payload;
    } catch (error) {
        const errorMessage = error.response?.data?.serviceMessage || error.message;
        toast.error(errorMessage);
        return thunkAPI.rejectWithValue(errorMessage);
    }
});

export const getAgentList = createAsyncThunk('getAgentList', async (org_id, thunkAPI) => {
    try {
        const response = await axios.get(`${baseUrlRfq}/agents/${org_id}`);
        const { payload } = response.data;
        return payload;
    } catch (error) {
        const errorMessage = error.response?.data?.serviceMessage || error.message;
        toast.error(errorMessage);
        return thunkAPI.rejectWithValue(errorMessage);
    }
});

export const createRfq = createAsyncThunk('createRfq', async (req, { dispatch, getState, thunkAPI }) => {
    const { reqPay, status, isEdit, allRfqReq } = req;
    try {
        const response = await axios.post(`${baseUrlRfq}/rfq`, reqPay);
        const { payload, serviceMessage, timestamp } = response.data;
        if (status === 'active') {
            toast.success(serviceMessage, {
                icon: <span className='msg-icon float-start ms-2 sf-check success-icon'></span>,
            });
        }
        if (response) {
            dispatch(getAllRfq(allRfqReq));
        }

        return { payload, isEdit, timestamp };
    } catch (error) {
        const errorMessage = error.response?.data?.serviceMessage || error.message;
        if (status === 'active') {
            toast.error(errorMessage);
        }

        return thunkAPI.rejectWithValue(errorMessage);
    }
});

export const getBrokerDashboardStats = createAsyncThunk('getBrokerDashboardStats', async (queryParams, thunkAPI) => {
    try {
        const response = await axios.get(`${baseUrlRfq}/brokerdashboardstats`, { params: queryParams });
        const { payload } = response.data;
        return payload;
    } catch (error) {
        return thunkAPI.rejectWithValue(error);
    }
});

export const updateRfq = createAsyncThunk('updateRfq', async (request, { dispatch, thunkAPI }) => {
    const { req, rfq_ulid } = request;

    try {
        const response = await axios.put(`${baseUrlRfq}/updateRfq/${rfq_ulid}`, req);
        if (response) {
            /* no-op */
        }
        const payload = response.data;
        return payload;
    } catch (error) {
        const errorMessage = error.response?.data?.serviceMessage || error.message;
        toast.error(errorMessage);
        return thunkAPI.rejectWithValue(errorMessage);
    }
});

export const getBrokerStats = createAsyncThunk('getBrokerStats', async (thunkAPI) => {
    try {
        const response = await axios.get(`${baseUrlRfq}/brokerStats`);
        const { payload } = response.data;
        return payload;
    } catch (error) {
        const errorMessage = error.response?.data?.serviceMessage || error.message;
        toast.error(errorMessage);
        return thunkAPI.rejectWithValue(errorMessage);
    }
});
export const getAllOpsBrokers = createAsyncThunk('getAllOpsBrokers', async (queryParams, thunkAPI) => {
    try {
        const response = await axios.get(`${baseUrlRfq}/allBrokers`, { params: queryParams });
        const { payload } = response.data;
        const { has_next, next_cursor } = response.data;
        return { payload, nextPage: { has_next: has_next, next_cursor: next_cursor } };
    } catch (error) {
        return thunkAPI.rejectWithValue(error);
    }
});
export const getlivepricefortopports = createAsyncThunk('getlivepricefortopports', async (thunkAPI) => {
    try {
        const response = await axios.get(`${baseUrlRfq}/livepricefortopports`);
        const { payload } = response.data;
        return payload;
    } catch (error) {
        return thunkAPI.rejectWithValue(error);
    }
});
